import { TextField } from "@mui/material";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Stack from "@mui/material/Stack";
import { useStore } from "../../contexts/store-provider";
import { observer } from "mobx-react";

const CustomDateInput = (props: any) => {
  const { preferencesStore } = useStore();
  
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    event.preventDefault();
  };
  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={preferencesStore.getLanguage === "en" ? "en" : "ja"}
      >
        <Stack spacing={3}>
          <DesktopDatePicker
            views={["year", "month", "day"]}
            inputFormat="YYYY-MM-DD"
            value={props.value ? dayjs(props.value) : null}
            disableFuture={props?.disableFuture ?? false }
            className={`datepicker-control ${
              props.className ? props.className : ""
            }`}
            onChange={(newValue: any) => {
              props.onChange(
                newValue ? dayjs(newValue).format("YYYY-MM-DD") : ""
              );
            }}
            renderInput={(params: any) => (
              <TextField {...params} onKeyDown={onKeyDown} />
            )}
          />
        </Stack>
      </LocalizationProvider>
    </>
  );
};

export default observer(CustomDateInput);
